import { ScrAuthorizationService } from '../../services/authorization.service';
import { Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ScrEnvironment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Component({
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent {

  constructor(
    public router: Router,
    public env: ScrEnvironment,
    @Inject(DOCUMENT) private doc: Document) {
  }
  
  public ScrAuthorizationService = ScrAuthorizationService;
}
